module.exports = __webpack_public_path__ + "static/images/ccc32cf8dba74fa02d586a8822e119ff.png";